import type { AiPart, PickType } from "@intelligems/ig-types";

/**
 * Type guard processor for workflow stream parts
 * Provides static utility methods for type checking
 */
export class UiMessagePartTypeGuardProcessor {
  static isTextPart(part: AiPart): part is PickType<AiPart, "text"> {
    return part.type === "text";
  }

  static isReasoningPart(part: AiPart): part is PickType<AiPart, "reasoning"> {
    return part.type === "reasoning";
  }

  static hasText(
    part: AiPart
  ): part is PickType<AiPart, "text"> | PickType<AiPart, "reasoning"> {
    return "text" in part;
  }

  // static isToolInputDeltaStreamPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "tool-input-delta"> {
  //   return part.type === "tool-input-delta";
  // }
  //
  // static isToolOutputDeltaStreamPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "tool-output-available"> {
  //   return part.type === "tool-output-available";
  // }
  //
  // static isReasoningStreamPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "reasoning-delta"> {
  //   return part.type === "reasoning-delta";
  // }
  //
  // static isReasoningStartPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "reasoning-start"> {
  //   return part.type === "reasoning-start";
  // }
  //
  // static isReasoningEndPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "reasoning-end"> {
  //   return part.type === "reasoning-end";
  // }
  //
  // static isFullReasoningPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "reasoning"> {
  //   return part.type === "reasoning";
  // }
  //
  // static isStartPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "start"> {
  //   return part.type === "start";
  // }
  //
  // static isFinishPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "finish"> {
  //   return part.type === "finish";
  // }
}
